import { useState } from 'react'

import { makeUrlUserActivateFirst } from '@/hooks/connectionData.tsx'
import { customPost } from '@/utils/customFetch.ts'

export enum PasswordActions {
  Activate = '0',
  Change = '1',
}

const useUserActivateFirst = () => {
  const [errorUserActivateFirst, setErrorUserActivateFirst] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const userActivateFirst = async ({
    value,
    email,
    password,
    action,
  }: {
    value: string
    email: string
    password: string
    action: PasswordActions
  }) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlUserActivateFirst()
      const res = await customPost<{ message: string }>(apiUrl, { value, email, password, action })

      setErrorUserActivateFirst(null)

      return res.message
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorUserActivateFirst(err)
      } else {
        setErrorUserActivateFirst(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorUserActivateFirst, loading, userActivateFirst }
}
export default useUserActivateFirst
